<template>
    <div class="msisdn-viewer border p-4 rounded">

        <b-row align-h="between">
            <b-col cols="auto"><h2 class="text-uppercase">{{ alias || 'N/A' }}</h2></b-col>
            <b-col cols="auto">
                <b-button @click="$refs.modalRecarga.show()">Recargar</b-button>
            </b-col>
        </b-row>

        <hr>

        <!-- Link de teléfono MSISDN -->
        <p class="msisdn">
            <a :href="'tel:' + msisdn">
                <i class="fa fa-phone fa-fw"></i>
                {{ msisdn | formatMSISDN }}
            </a>
        </p>

        <!-- Gráfica de barra animada -->
        <div class="consumption-bar-container">

            <div class="consumption-bar">
                <div  class="consumption-bar-fill" 
                    :style="{ width: percentageAvailableDelayed + '%', transitionDuration: fillDuration + 'ms' }"
                    :class="{ 'high-consumption': percentageAvailableDelayed < 20 }">
                    &nbsp;
                </div>
            </div>

            <p class="consumption-text">
                {{ percentageAvailable.toFixed(1) }}% disponible
            </p>

        </div>
    
        <!-- Visualización de datos -->
        <template v-if="dataBootstrapFormat">
            <ul class="list-group mb-3">
                <li class="list-group-item d-flex justify-content-between align-items-center" v-if="planContratado">
                    <strong>Plan contratado:</strong>
                    <span class="badge badge-primary badge-pill">{{ planContratado }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <strong>Fecha de corte mensual:</strong>
                    <span class="badge badge-primary badge-pill">{{ cFechaCorteMensual }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <strong>Datos totales:</strong>
                    <span class="badge badge-primary badge-pill">
                        {{ cDatosTotalesDesdeRegistros }}
                    </span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center" :class="{ 'low-data-available': totalDisponible < 512 }">
                    <strong>Datos disponibles:</strong>
                    <span class="badge badge-primary badge-pill">
                        {{ totalDisponible >= 1024 ? (totalDisponible / 1024).toFixed(2) + ' GB' : totalDisponible + ' MB' }}
                    </span>
                </li>
            </ul>
        </template>

        <!-- Visualización tradicional de datos -->
        <template v-else>
            <p><strong>Datos disponibles:</strong> {{ totalDisponible }} MB</p>
        </template> 

        <hr>

        <!-- Beneficios Incluidos -->
        <div v-if="beneficiosIncluidos && beneficiosIncluidos.length > 0" class="mb-3">
            <h5 class="mb-2">Beneficios Incluidos</h5>
            <div>
                <span v-for="(beneficio, index) in beneficiosIncluidos" 
                      :key="'beneficio-' + index"
                      class="badge badge-success badge-pill mr-2 mb-2">
                    {{ beneficio }}
                </span>
            </div>
        </div>

        <hr>

        <!-- Otros Beneficios -->
        <div v-if="otrosBeneficios && otrosBeneficios.length > 0" class="mb-3">
            <h5 class="mb-2">Otros Beneficios</h5>
            <div>
                <span v-for="(beneficio, index) in otrosBeneficios" 
                      :key="'otro-' + index"
                      class="badge badge-info badge-pill mr-2 mb-2">
                    {{ beneficio }}
                </span>
            </div>
        </div>

        <modal-recarga :msisdn="msisdn" ref="modalRecarga"/>
    </div>
</template>

<script>
import ModalRecarga from './modal-recarga.vue';
export default {
    name: 'MsisdnViewer',
    components: {
        ModalRecarga
    },
    props: {
        registros: {
            type: Array,
            default: () => [
                // {"unusedAmt":"0","totalAmt":"2662","expireDate":"20260313000000","leyend":"0.000 Mb disponibles de un total de 2662.000 Mb"}
            ]
        },
        beneficiosIncluidos: {
            type: Array,
            default: () => [
                'Redes sociales ilimitadas',
                'Llamadas y mensajes ilimitados',
            ]
        },
        otrosBeneficios: {
            type: Array,
            default: () => [
                'Datos USA y Canada incluidos'
            ]
        },
        planContratado: {
            type: String
        },
        fechaCorteMensual: {
            type: [String, Date],
            default: 'N/A' // P. E: 20260301000000
        },
        dataBootstrapFormat: {
            type: Boolean,
            default: true
        },
        msisdn: {
            type: String,
            required: true
        }, 
        alias: {
            type: String,
            default: ''
        }, 
        totalDisponible: {
            type: [Number, String],
            default: 50000
        },
        porcentajeDisponible: {
            type: [Number, String],
            default: 90
        },
        fillDuration: {
            type: Number,
            default: 1200
        },
        fillDelay: {
            type: Number,
            default: 300
        }
    },
    computed: {
        cDatosTotalesDesdeRegistros(){
            if (!this.registros || this.registros.length === 0) return 'N/A';
            const total = this.registros.reduce((acc, registro) => acc + parseFloat(registro.totalAmt), 0);
            return total >= 1024 ? (total / 1024).toFixed(2) + ' GB' : total.toFixed(0) + ' MB';
        },
        cFechaCorteMensual(){
            if (!this.fechaCorteMensual) return 'N/A';
            else {
                let dateObj;
                if (typeof this.fechaCorteMensual === 'string' && this.fechaCorteMensual.length === 14) {
                    // Parse format: "20260301000000" (YYYYMMDDhhmmss)
                    const year = this.fechaCorteMensual.substring(0, 4);
                    const month = this.fechaCorteMensual.substring(4, 6);
                    const day = this.fechaCorteMensual.substring(6, 8);
                    dateObj = new Date(year, parseInt(month) - 1, day);
                } else {
                    dateObj = new Date(this.fechaCorteMensual);
                }
                return dateObj.toLocaleDateString('es-ES', { day: '2-digit', month: 'long', year: 'numeric' });
            }
        },
        percentageAvailableDelayed() {
            if (!this.fillStarted) return 0;
            else return (this.percentageAvailable);
        },
        percentageAvailable() {
            return parseFloat(this.porcentajeDisponible)
        }
    },
    data: () => {
        return {
            fillStarted: false
        };
    },
    mounted() {
        // You can add any additional logic here if needed when the component is mounted
        setTimeout(() => {
            this.fillStarted = true;
        }, this.fillDelay);
    }
};
</script>

<style lang="scss">
@import '@/scss/app.scss';
.msisdn-viewer {
    // background-color: red;
    .msisdn {
        font-size: 1.5rem;
        font-weight: bold;
    }
    .consumption-bar-container {
        margin-top: 20px;

        .consumption-bar {
            width: 100%;
            height: 25px;
            background-color: #e0e0e0;
            border-radius: 12px;
            overflow: hidden;
            .consumption-bar-fill {
                height: 100%;
                background-color: $primary;
                width: 0;
                transition: width 0.5s ease-out;
                &.high-consumption {
                    background-color: $danger;
                }
            }
        }
        .consumption-text {
            text-align: center;
            margin-top: 5px;
            font-weight: bold;
        }
    }
    .low-data-available {
        strong {
            color: #856404 !important; /* Dark yellow text */
        }
        .badge {
            background-color: #fff3cd !important; /* Light yellow background */
            color: #852204 !important; /* Dark yellow text */
        }
    }
}
</style>